export default "__VITE_ASSET__DcTsAnVO__"